import { useState, useContext } from "react";
import HeaderBar from "../../components/HeaderBar";
import VehicleLayoutWrapper from "../../components/VehicleLayoutWrapper";
import getCurrentSkin from "../../utils/getCurrentSkin";
import { ThemeContext } from "../../context/ThemeContext";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { FaSave, FaTimes, FaPlus, FaTools } from "react-icons/fa";

const TyreMaintenanceCostReport = () => {
  const navigate = useNavigate();
  const { isDark, skin, setSkin } = useContext(ThemeContext);
  const currentSkin = getCurrentSkin(skin);
  const { baseColor, baseShade } = currentSkin;
  const buttonClass = `bg-${baseColor}-${baseShade}`;
  const hoverClass = `hover:bg-${baseColor}-700`;
  
  // Form state
  const [formData, setFormData] = useState({
    vehicleCode: "",
    vehicleRegNo: "",
    tyreSerialNo: "",
    tyrePosition: "",
    maintenanceType: "",
    maintenanceDate: new Date().toISOString().split('T')[0],
    maintenanceCost: "",
    maintenanceDetails: "",
    nextMaintenanceDate: "",
    technician: "",
    remarks: ""
  });

  const inputClass = `w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
    isDark
      ? "bg-gray-700/30 border-gray-600 text-white"
      : "bg-white border-gray-300 text-gray-900"
  }`;

  const selectClass = `w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
    isDark
      ? "bg-gray-700/30 border-gray-600 text-white"
      : "bg-white border-gray-300 text-gray-900"
  }`;

  const labelClass = `block text-sm font-medium mb-2 ${isDark ? "text-gray-300" : "text-gray-700"}`;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Validate required fields
    if (!formData.vehicleCode || !formData.tyreSerialNo || !formData.maintenanceType || 
        !formData.maintenanceDate) {
      toast.error("Please fill in all required fields!");
      return;
    }
    
    // Submit form data
    toast.success("Tyre maintenance record saved successfully!");
    // In a real app, you would call an API here
  };

  const handleCancel = () => {
    navigate(-1); // Go back to previous page
  };

  const handleReset = () => {
    setFormData({
      vehicleCode: "",
      vehicleRegNo: "",
      tyreSerialNo: "",
      tyrePosition: "",
      maintenanceType: "",
      maintenanceDate: new Date().toISOString().split('T')[0],
      maintenanceCost: "",
      maintenanceDetails: "",
      nextMaintenanceDate: "",
      technician: "",
      remarks: ""
    });
    toast.info("Form has been reset");
  };

  return (
    <VehicleLayoutWrapper>
      <div className={`min-h-screen p-6 ${isDark ? "bg-gray-900" : "bg-gray-100"}`}>
        <HeaderBar
          title={<span className="font-dmserif text-3xl">TYRE MAINTENANCE</span>}
          setSkin={setSkin}
          currentSkin={skin}
        />

        <div className={`p-6 mt-6 rounded-2xl shadow-xl border ${
          isDark
            ? "bg-gradient-to-br from-white/20 to-white/5 backdrop-blur-md border-white/10 text-white"
            : `bg-white ${currentSkin.glass} text-black`
        }`}>
          <form onSubmit={handleSubmit}>
            {/* Header Section */}
            <div className="flex justify-between items-center mb-8">
              <div className="flex items-center gap-4">
                <h1 className={`text-2xl font-bold ${
                  isDark ? "text-white" : "text-gray-900"
                }`}>
                  Tyre Maintenance
                </h1>
                <div className={`px-3 py-1 rounded-full text-sm font-medium ${
                  isDark 
                    ? "bg-blue-900 text-blue-100" 
                    : "bg-blue-100 text-blue-800"
                }`}>
                  <FaTools className="inline mr-2" />
                  New Record
                </div>
              </div>
              
              <div className="flex items-center gap-3">
              
                
                   <button
                onClick={() => navigate("/vehicle/TyreCostReport")}
                className={`flex items-center gap-2 ${buttonClass} ${hoverClass} text-white px-4 py-2 rounded transition-colors`}
              >
                <FaPlus className="w-4 h-4" />
               Tyre Cost
              </button>
              </div>
            </div>

            {/* Form Fields */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
              {/* Left Column */}
             
            </div>
            
            {/* Form Actions */}
           
          </form>

          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            closeOnClick
            pauseOnHover
            theme={isDark ? "dark" : "light"}
          />
        </div>
      </div>
    </VehicleLayoutWrapper>
  );
};

export default TyreMaintenanceCostReport;